/* eslint-disable @typescript-eslint/naming-convention */
import { APP_INITIALIZER, enableProdMode, importProvidersFrom, NgModule } from '@angular/core';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { APP_ROUTES } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CurrentOrgInterceptor } from './app/_interceptors/current-org-interceptor';
import { provideRouter } from '@angular/router';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { StartUpService } from './app/_services/startup.service';

if (environment.production) {
    enableProdMode();
}

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
        full: 'MMMM DD, YYYY'
    }
};

export function getToken() {
    return localStorage.getItem('lido-bo-token');
}

export function startUpInitializer(startUpService: StartUpService) {
    return () => startUpService.init();
}

// function _allowedDomains(): string[] {
//     let domains: string[] = [];
//     domains = domains.concat(['http://lidoapi.org', 'https://lidoapi.org']);
//     if (!environment.production) domains.push('localhost:8888');
//     return domains;
// }

// disallowedRoutes: ['localhost:8888/api/auth', 'http://lidoapi.org/api/auth', 'https://lidoapi.org/api/auth'],

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            AuthModule.forRoot({
                domain: environment.auth0Domain,
                clientId: environment.auth0ClientId,
                authorizationParams: {
                    redirect_uri: window.location.origin,
                    audience: environment.auth0Audience
                },
                httpInterceptor: {
                    allowedList: [
                        {
                            uri: `${environment.apiUrl}auth/register`,
                            allowAnonymous: true,
                        },
                        {
                            uri: `${environment.apiUrl}*`,
                            tokenOptions: {
                                authorizationParams: {
                                    audience: environment.auth0Audience,
                                }
                            }
                        }]
                }
            })
        ),
        provideRouter(APP_ROUTES),
        provideNativeDateAdapter(),
        provideAnimations(),
        provideHttpClient(
            withInterceptorsFromDi()
        ),
        { provide: APP_INITIALIZER, useFactory: startUpInitializer, deps: [StartUpService], multi: true },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: HTTP_INTERCEPTORS, useClass: CurrentOrgInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    ]
}).catch(err => console.error(err));

